import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import PortalCheckBox from '@nexidigital/portalcheckbox'
import PortalTextLink from '@nexidigital/portaltextlink'
import { messages } from './languageModule'
import './TermsCheckBox.scss'

const TermsCheckBox = ({ disabled, checked, onCheckChange, actions }) => {
  const intl = useIntl()
  return (
    <PortalCheckBox
      handleChange={() => {}}
      id='tac_checkbox'
      centered
      smallSpace
      onChange={() => onCheckChange(!checked)}
      options={[
        {
          id: 'tac',
          disabled: disabled,
          label: (
            <div className='tac_checkbox_label'>
              {intl.formatMessage(messages.termsAgreementText) + ' '}
              <PortalTextLink
                id='termsAndConditions'
                label={intl.formatMessage(messages.termsAndConditions)}
                ariaLabel={intl.formatMessage(messages.termsAndConditions)}
                underline='always'
                onClick={() => actions.openTermsAndConditionsDisputlessPopup()}
              />
            </div>
          ),
          checked: checked,
          value: 'tac'
        }
      ]}
    />
  )
}

TermsCheckBox.propTypes = {
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  onCheckChange: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    openTermsAndConditionsDisputlessPopup: PropTypes.func.isRequired
  }).isRequired
}

TermsCheckBox.defaultProps = {
  // Add here some default propTypes values
  disabled: false,
  checked: false,
  onCheckChange: () => {}
}

export default TermsCheckBox
